import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CartItem = ({ item, onQuantityChange, onRemove, isProcessing }) => {
  const menuItem = item?.menu_item;
  const price = parseFloat(menuItem?.price_per_plate || 0);
  const subtotal = price * item?.quantity;

  const handleIncrement = () => {
    onQuantityChange(item?.id, item?.quantity + 1);
  };

  const handleDecrement = () => {
    if (item?.quantity > 1) {
      onQuantityChange(item?.id, item?.quantity - 1);
    }
  };

  const handleRemove = () => {
    onRemove(item?.id);
  };

  return (
    <div className="flex gap-4 p-4 bg-background rounded-lg hover:bg-muted/50 transition-smooth">
      {/* Item Image */}
      <img
        src={menuItem?.image || 'https://via.placeholder.com/120'}
        alt={menuItem?.image_alt || menuItem?.name}
        className="w-24 h-24 rounded-lg object-cover flex-shrink-0"
      />

      {/* Item Details */}
      <div className="flex-1 min-w-0">
        <h4 className="font-heading font-bold text-foreground mb-1 truncate">
          {menuItem?.name}
        </h4>
        <p className="text-sm text-muted-foreground mb-2 line-clamp-2">
          {menuItem?.description}
        </p>

        {/* Tags */}
        {menuItem?.dietary_tags && menuItem?.dietary_tags?.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-3">
            {menuItem?.dietary_tags?.slice(0, 3)?.map((tag, index) => (
              <span
                key={index}
                className="px-2 py-0.5 bg-primary/10 text-primary text-xs rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        {/* Quantity Controls and Price */}
        <div className="flex items-center justify-between">
          {/* Quantity Controls */}
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecrement}
              disabled={isProcessing || item?.quantity <= 1}
              className="w-8 h-8 p-0 flex items-center justify-center"
            >
              <Icon name="Minus" size={14} />
            </Button>
            <span className="w-12 text-center font-medium text-foreground">
              {item?.quantity}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={handleIncrement}
              disabled={isProcessing}
              className="w-8 h-8 p-0 flex items-center justify-center"
            >
              <Icon name="Plus" size={14} />
            </Button>
          </div>

          {/* Price */}
          <div className="text-right">
            <p className="text-sm text-muted-foreground">${price?.toFixed(2)} each</p>
            <p className="font-heading font-bold text-foreground">
              ${subtotal?.toFixed(2)}
            </p>
          </div>
        </div>
      </div>

      {/* Remove Button */}
      <button
        onClick={handleRemove}
        disabled={isProcessing}
        className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-muted-foreground hover:text-destructive hover:bg-destructive/10 rounded-lg transition-smooth disabled:opacity-50"
        aria-label="Remove item"
      >
        <Icon name="X" size={18} />
      </button>
    </div>
  );
};

export default CartItem;